var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"revoke"},[(_vm.isMyMsg)?_c('p',{},[_vm._v(_vm._s(_vm.$t("im.msgwithdraw")))]):_c('p',[_vm._v(_vm._s(_vm.msgWrapper.msg.msgBody.content.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }